import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material"
import type React from "react"
import Button from "./Button"

type Props = {
  open: boolean
  onClose?: () => void
  onConfirm?: () => void
  title: string
  cancelLabel?: string
  confirmLabel?: string
  disableBtns?: boolean
  hideCancelBtn?: boolean
  children?: React.ReactNode
} & Omit<
  React.ComponentProps<typeof Dialog>,
  "open" | "onClose" | "title" | "children"
>

export const Modal = ({
  open,
  onClose,
  onConfirm,
  title,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  children,
  disableBtns = false,
  hideCancelBtn = false,
  ...props
}: Props) => {
  const handleClose: NonNullable<
    React.ComponentProps<typeof Dialog>["onClose"]
  > = () => {
    onClose?.()
  }

  return (
    <Dialog open={open} onClose={handleClose} {...props}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <div style={{ paddingTop: 8 }}>{children}</div>
      </DialogContent>
      <DialogActions>
        {!hideCancelBtn && (
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ width: 101 }}
            data-testid="modal-cancel-button"
            disabled={disableBtns}
          >
            {cancelLabel}
          </Button>
        )}
        {onConfirm && (
          <Button
            onClick={onConfirm}
            variant="contained"
            color="primary"
            style={{ width: "auto", marginLeft: 20 }}
            data-testid="modal-confirm-button"
            disabled={disableBtns}
          >
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
